import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';

// Persistent "AI-generated, analysis not a recommendation" notice. Rendered at
// the bottom of every ARE panel/sub-mask (assistant, runs, run detail, narrative
// view) and inside the voice overlay. Text follows the selected UI language via
// the `are_disclaimer` i18n key. Pass `sx` to tweak placement (e.g. absolute in
// the voice overlay).
function AreDisclaimer({ sx, textKey = 'are_disclaimer' }) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        px: 1,
        py: 0.5,
        flexShrink: 0,
        ...sx,
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 13, color: 'primary.main', display: 'block', flexShrink: 0 }} />
      <Typography sx={{ fontSize: 10.5, lineHeight: 1, color: 'text.disabled' }}>
        {t(textKey)}
      </Typography>
    </Box>
  );
}

export default AreDisclaimer;
